import { Component, input, output } from '@angular/core';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { LiteralService, UtilsService } from 'src/app/services';
import { images } from 'src/images';

export interface MultiConfigUpdateOptions {
  deleteAvailabilities: boolean;
  deleteComment: string;
  sendNotification: boolean;
  refund: boolean;
  cancelRelated: boolean;
  fullRefund: boolean;
}

@Component({
  selector: 'app-modal-confirm-multi-config',
  templateUrl: './modal-confirm-multi-config.component.html',
  styleUrl: './modal-confirm-multi-config.component.scss',
  standalone: false
})
export class ModalConfirmMultiConfigComponent {

  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly updating = input<boolean>(false);
  readonly configData = input<any>();
  readonly action = output<MultiConfigUpdateOptions>();

  public images = images;

  get hasDateChanges(): boolean {
    const config = this.configData();
    if (!config) return false;
    return !!(config.fromDate || config.toDate || config.creationAdvancedDays);
  }

  // Delete options
  public deleteAvailabilities = false;
  public deleteComment = '';
  public sendNotification = true;
  public refund = true;
  public cancelRelated = true;
  public fullRefund = false;

  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/bus.json'
  };

  constructor(public literalService: LiteralService, public utilsService: UtilsService) {}

  onSubmit() {
    this.action.emit({
      deleteAvailabilities: this.deleteAvailabilities,
      deleteComment: this.deleteAvailabilities ? this.deleteComment : '',
      sendNotification: this.deleteAvailabilities ? this.sendNotification : false,
      refund: this.deleteAvailabilities ? this.refund : false,
      cancelRelated: this.deleteAvailabilities ? this.cancelRelated : false,
      fullRefund: this.deleteAvailabilities ? this.fullRefund : false
    });
  }

  close() {
    this.modal()?.hide();
    this.resetForm();
  }

  private resetForm() {
    this.deleteAvailabilities = false;
    this.deleteComment = '';
    this.sendNotification = true;
    this.refund = true;
    this.cancelRelated = true;
    this.fullRefund = false;
  }
}
